import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListWidgetComponentFactory } from '~/components/MyWorkspace/ListWidget';
import { People } from '~/services/Http';
import { useGetTeamTasks } from '~/services/Http/hooks';

import { WidgetProps, getWidgetDataRequestRoles } from '../../data/widgets';

import { Task } from './components/Task';
import { TaskInfo } from './components/TaskInfo';

export interface Props extends WidgetProps {}

const TeamTasksWidgetComponent = ListWidgetComponentFactory({
  ListItemComponent: Task,
  getIdentifier: (item: People.TaskDto) => item.id,
  ListItemInfoComponent: TaskInfo,
  dataCy: 'team-tasks-widget',
});

export const TeamTasksWidget: React.FC<Props> = ({ title, config }) => {
  const { t } = useTranslation();

  const dataRequestRoles = useMemo(() => {
    return getWidgetDataRequestRoles(config?.role);
  }, [config]);

  const statuses = useMemo(
    () => [People.TaskStatusEnum.NEW, People.TaskStatusEnum.IN_PROGRESS],
    [],
  );
  const getTeamTasksReqParams = {
    employeeId: 'me',
    statuses,
    roles: dataRequestRoles,
  };
  const {
    data: tasks,
    loading,
    failedToLoad,
  } = useGetTeamTasks(getTeamTasksReqParams);

  return (
    <TeamTasksWidgetComponent
      title={title || t('teamTasks')}
      data={tasks}
      loading={loading}
      failedToLoad={failedToLoad}
      noDataMessage={t('noTasks')}
    />
  );
};
